import { useEffect, useState } from 'react';
import {
  Avatar,
  Grid,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Person, Supervisor } from '../../schema/person';
import CompanyFromInput from '../formInput/CompanyFromInput';
import { api } from '../../api';
import DepartmentFromInput from '../formInput/DepartmentFromInput';

const defaultPhotoURL =
  'https://minimal-kit-react.vercel.app/static/mock-images/avatars/avatar_default.jpg';
interface PersonProps {
  person_id?: string | number;
  editable?: boolean;
}

const PersonDetail: React.FC<PersonProps> = ({ person_id, editable }: PersonProps) => {
  const [photo, set_photo] = useState<string>('');
  const [personnal_id, set_personnal_id] = useState<string>('');
  const [title_name, set_title_name] = useState<string>('');
  const [first_name, set_first_name] = useState<string>('');
  const [last_name, set_last_name] = useState<string>('');
  const [phone_number, set_phone_number] = useState<string>('');
  const [email, set_email] = useState<string>('');
  const [position, set_position] = useState<string>('');
  const [person_company, set_person_company] = useState<number | null>(null);
  const [person_company_name, set_person_company_name] = useState<string>('');
  const [person_type, set_person_type] = useState<number | null>(null);
  const [employee_code, set_employee_code] = useState<string>('');

  const [department_id, set_department_id] = useState<number | null>(null);
  const [department_name, set_department_name] = useState<string>('');

  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openSuccessDialog = () => {
    setIsOpenSuccessDialog(true);
    setTimeout(() => {
      setIsOpenSuccessDialog(false);
    }, 1000);
  };
  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!editable) {
      return;
    }
    if (isLoading) {
      return;
    }
    if (person_id) {
      setIsLoading(true);
      api
        .put(`/person/${person_id}`, {
          personnal_id,
          title_name,
          first_name,
          last_name,
          phone_number,
          email,
          position,
          company_id: person_company,
          person_type_id: person_type
        })
        .then(() => {
          openSuccessDialog();
        })
        .finally(() => setIsLoading(false));
    }
  };
  useEffect(() => {
    if (person_id) {
      api
        .get<Person>(`/person/${person_id}`)
        .then((res) => {
          const { data } = res;
          set_photo(data.photo);
          set_personnal_id(data.personnal_id);
          set_title_name(data.title_name);
          set_first_name(data.first_name);
          set_last_name(data.last_name);
          set_phone_number(data.phone_number);
          set_email(data.email);
          set_position(data.position?.position_name || '');
          set_person_company(data.company_id);
          set_person_company_name(data.company.company_name);
          set_person_type(data.person_type_id);
          set_employee_code(data.employee_code ? data.employee_code : '');
          set_department_id(data.department_id ? data.department_id : null);
          set_department_name(
            data.department?.department_name ? data.department?.department_name : ''
          );
        })
        .catch((res) => res.json());
    }
  }, [person_id]);

  return (
    <>
      <Typography variant="h6">ข้อมูลบุคลากร</Typography>
      <Grid container spacing={1} direction="column" alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <Avatar
            src={photo ? photo : defaultPhotoURL}
            alt={title_name ? title_name : ''}
            sx={{ width: 200, height: 200 }}
          />
        </Grid>
      </Grid>

      <Form onSubmit={handleFormSubmit} sx={{ mt: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="เลขประจำตัวประชาชน หรือ Passport"
              variant="outlined"
              placeholder="เลขประจำตัวประชาชน หรือ Passport"
              value={personnal_id}
              onChange={(e) => set_personnal_id(e.target.value)}
              InputProps={{ readOnly: !editable }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="คำนำหน้า"
              variant="outlined"
              placeholder="คำนำหน้า"
              value={title_name}
              onChange={(e) => set_title_name(e.target.value)}
              InputProps={{ readOnly: !editable }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="ชื่อ"
              variant="outlined"
              placeholder="ชื่อ - นามสกุล"
              value={first_name}
              onChange={(e) => set_first_name(e.target.value)}
              InputProps={{ readOnly: !editable }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="นามสกุล"
              variant="outlined"
              placeholder="นามสกุล"
              value={last_name}
              onChange={(e) => set_last_name(e.target.value)}
              InputProps={{ readOnly: !editable }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="เบอร์โทรศัพท์"
              variant="outlined"
              placeholder="เบอร์โทรศัพท์"
              value={phone_number}
              onChange={(e) => set_phone_number(e.target.value)}
              InputProps={{ readOnly: !editable }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="อีเมล"
              variant="outlined"
              placeholder="อีเมล"
              value={email}
              onChange={(e) => set_email(e.target.value)}
              InputProps={{ readOnly: !editable }}
            />
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <CompanyFromInput
                value={person_company}
                onChange={(value) => set_person_company(value)}
              />
            ) : (
              <TextField
                fullWidth
                label="บริษัท"
                variant="outlined"
                placeholder="บริษัท"
                value={person_company_name}
                InputProps={{ readOnly: !editable }}
              />
            )}
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <TextField
                fullWidth
                label="รหัสพนักงาน"
                variant="outlined"
                placeholder="รหัสพนักงาน"
                value={employee_code}
                onChange={(e) => set_employee_code(e.target.value)}
                InputProps={{ readOnly: !editable }}
              />
            ) : (
              <TextField
                fullWidth
                label="รหัสพนักงาน"
                variant="outlined"
                placeholder="รหัสพนักงาน"
                value={employee_code}
                InputProps={{ readOnly: !editable }}
              />
            )}
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <DepartmentFromInput
                value={department_id}
                onChange={(value) => set_department_id(value)}
              />
            ) : (
              <TextField
                fullWidth
                label="หน่วยงาน"
                variant="outlined"
                placeholder="หน่วยงาน"
                value={department_name}
                InputProps={{ readOnly: !editable }}
              />
            )}
          </Grid>

          <Grid item xs={6}></Grid>
        </Grid>
        {editable ? (
          <Grid container columns={2} spacing={2} direction={'row-reverse'}>
            <Grid item>
              <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 4 }}>
                บันทึก
              </Button>
            </Grid>
          </Grid>
        ) : null}
      </Form>
      <Dialog open={isOpenSuccessDialog} onClose={() => setIsOpenSuccessDialog(false)}>
        <DialogTitle>{'Success'}</DialogTitle>
        <DialogContent>
          <DialogContentText>อัพเดทข้อมูลสำเร็จ</DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PersonDetail;

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
